<div class="form-group">
    <label class="input-label">{{ 'Help text' | translate }}</label>
    <input type="text"
           name="fieldOptions.tooltip"
           value="{{fieldOptions.tooltip}}"
           [(ngModel)]="fieldOptions.tooltip"
           (ngModelChange)="dataChangedEvent($event)"
           class="form-control">
</div>